import React from 'react'

const DealerDegitalRetail = () => {
  return (
    <section id="c-sectionDigitalRetail" className="c-sectionWrapper">
		<div className="container">
			<div className="c-sectionHeader">
				<h5 className="c-heading46Bold">Digital Loan platform like you have never seen before</h5>
				<div className="row justify-content-lg-center">
					<div className="col-lg-8 col-md-12">						
						{/* <!-- <p className="c-para22Regular">Lorem Ipsum is simply dummy text of the printing and type and setting industry Lorem Ipsum is simply dummy .</p> --> */}
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-md-5 col-12 text-center c-digitalRetailImageCol">
					<img src="./images/dealer/section_digital_retail.png" className="img-fluid c-digitalRetailImage" alt="" title="" />
				</div>
				<div className="col-md-6 col-12 c-digitalRetailFeaturesListCol">
					<div className="c-digitalRetailFeaturesList">
						<div className="c-digitalRetailFeature">
							<div className="c-drfIcon">
								<img src="./images/dealer/dr_in_store.png" title="" alt="" />
							</div>
							<div className="c-drfInfo">
								<div className="c-drfTitle">Self-financing portal </div>
								{/* <!-- <div className="c-drfPara">Digitize your showroom and close more deals in less time.</div> --> */}
							</div>
						</div>
						<div className="c-digitalRetailFeature">
							<div className="c-drfIcon">
								<img src="./images/dealer/dr_online_retail.png" title="" alt="" />
							</div>
							<div className="c-drfInfo">
								<div className="c-drfTitle">Dealer's Executive mobile application</div>
								{/* <!-- <div className="c-drfPara">Digitize your showroom and close more deals in less time.</div> --> */}
							</div>
						</div>
						<div className="c-digitalRetailFeature">
							<div className="c-drfIcon">
								<img src="./images/dealer/dr_real_time.png" title="" alt="" />
							</div>
							<div className="c-drfInfo">
								<div className="c-drfTitle">Real time Approvals </div>
								{/* <!-- <div className="c-drfPara">Digitize your showroom and close more deals in less time.</div> --> */}
							</div>
						</div>
						<div className="c-digitalRetailFeature">
							<div className="c-drfIcon">
								<img src="./images/dealer/dr_manager_portal.png" title="" alt="" />
							</div>
							<div className="c-drfInfo">
								<div className="c-drfTitle">Paperless approach</div>
								{/* <!-- <div className="c-drfPara">Digitize your showroom and close more deals in less time.</div> --> */}
							</div>
						</div>	

					</div>
				</div>
			</div>			
		</div>
	</section>
  )
}

export default DealerDegitalRetail